import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=b080d31e&scoped=true"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"
import style0 from "./NavHeader.vue?vue&type=style&index=0&id=b080d31e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b080d31e",
  null
  
)

export default component.exports